import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-battery-half-sharp",
  "use": "icon-battery-half-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-battery-half-sharp\"><title>Battery Half</title><path d=\"M17 384h432V128H17zm32-224h368v192H49z\" /><path d=\"M70.69 182.92H256v146.16H70.69zM465 202.67h32v106.67h-32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol